/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ComplianceTimelineEventPayload } from './';
import {
    ComplianceTimelineEventPayloadFromJSON,
    ComplianceTimelineEventPayloadFromJSONTyped,
    ComplianceTimelineEventPayloadToJSON,
} from './';

/**
 * 
 * @export
 * @interface BankAccountEventTimelinePayload
 */
export interface BankAccountEventTimelinePayload extends ComplianceTimelineEventPayload {
    /**
     * 
     * @type {string}
     * @memberof BankAccountEventTimelinePayload
     */
    bankAccountType: string;
}

/**
 * Check if a given object implements the BankAccountEventTimelinePayload interface.
 */
export function instanceOfBankAccountEventTimelinePayload(value: object): value is BankAccountEventTimelinePayload {
    if (!('bankAccountType' in value) || value['bankAccountType'] === undefined) return false;
    return true;
}

export function BankAccountEventTimelinePayloadFromJSON(json: any): BankAccountEventTimelinePayload {
    return BankAccountEventTimelinePayloadFromJSONTyped(json, false);
}

export function BankAccountEventTimelinePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccountEventTimelinePayload {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadFromJSONTyped(json, ignoreDiscriminator),
        'bankAccountType': json['bankAccountType'],
    };
}

export function BankAccountEventTimelinePayloadToJSON(value?: BankAccountEventTimelinePayload | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ComplianceTimelineEventPayloadToJSON(value, true),
        'bankAccountType': value['bankAccountType'],
    };
}

